import { IN3 } from '../in3/sdk-wasm.js'
import Config from './config'
import Account from './api/account'
import Eth from './api/eth'
import Utils from './api/utils'
import Btc from './api/btc'
import Ipfs from './api/ipfs'
import Zksync from './api/zksync'
import Wallet from './api/wallet'
import Notification from './api/notification'

/**
 * The main SDK-class which can be configured for different chains or environments.
 */
export class SDK {
    in3: IN3
    private WalletInstance: Wallet

    // lazy instantiation
    private notificationInstance: Notification;

    /**
     * creates a new SDK.
     * @param conf the configuration to apply.
     */
    constructor(conf?: Config) {
        this.in3 = new IN3({ allowed_confs: ["notifications", "custodyLibBlockchainProfile"], ...conf } as any)
    }

    /**
     * changes the current configuration.
     */
    configure(conf?: Config) {
        this.in3.setConfig(conf as any)
    }

    /**
     * returns the current configuration.
     */
    get config(): Config {
        return this.in3.execLocal("in3_getConfig")
    }

    /**
     * the ethereum API
     */
    get eth(): Eth {
        return new Eth(this.in3)
    }

    /**
     * The Bitcoin API
     */
    get btc() {
        return new Btc(this.in3)
    }

    /**
     * The IPFS-API
     */
    get ipfs() {
        return new Ipfs(this.in3)
    }

    /**
     * The zksync API
     */
    get zksync() {
        return new Zksync(this.in3)
    }

    /**
     * Utils for dealing with ABI encoding and more.
     */
    get util(): Utils {
        return new Utils(this.in3)
    }

    /**
     * Account and signing handling.
     */
    get account() {
        return new Account(this.in3)
    }

    get wallet() {
        if (!this.WalletInstance) {
            this.WalletInstance = new Wallet(this.config);
        }
        return this.WalletInstance;
    }

    /**
     * Notification send/receive API
     */
    get notification() {
        if (!this.notificationInstance) {
            this.notificationInstance = new Notification(this);
        }
        return this.notificationInstance;
    }

    /**
     * frees the resources for the SDK.
     * This must be called when the SDK is disposed. 
     * Since there is not automatic dispose handling in javascript, you need to call it manually in order to avoid memory leaks.
     */
    free() {
        this.in3.free()
    }

}
export default SDK
export {
    IN3,
}
